import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { AdminService } from "../../../services/admin-service";

export const Userpasswordreset = (props) => {
  const { adminID } = useParams();

  const [submitloading, setSubmitLoading] = useState(true);

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    try {
      await AdminService.adminPasswordUpdate(
        adminID,
        values.newpassword,
        values.confirm_password
      );

      setSubmitLoading(true);
      notify("Admin password successfully updated");
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  useEffect(() => {}, []);

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Password Reset</h6>
            </div>
            <div className="ms-panel-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  newpassword: "",
                  confirm_password: "",
                }}
                validationSchema={Yup.object().shape({
                  newpassword: Yup.string()
                    .required("Required")
                    .min(6, "password must have at least 6 characters")
                    .max(10, "password must have less than 10 characters"),

                  confirm_password: Yup.string().when("newpassword", {
                    is: (val) => (val && val.length > 0 ? true : false),
                    then: Yup.string().oneOf(
                      [Yup.ref("newpassword")],
                      "Both password need to be the same"
                    ),
                  }),
                })}
                onSubmit={onSubmitForm}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  values,
                  submitForm,
                  isValid,
                }) => (
                  <div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">New Password</label>
                        <div className="input-group">
                          <input
                            name="newpassword"
                            type="password"
                            className="form-control"
                            id="passwordid"
                            placeholder="Password"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.newpassword}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.password && errors.password}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">
                          Confirm Password
                        </label>
                        <div className="input-group">
                          <input
                            name="confirm_password"
                            type="password"
                            className="form-control"
                            id="confirm_password_id"
                            placeholder="Confirm Password"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.confirm_password}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.confirm_password && errors.confirm_password}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2" hidden={submitloading}>
                      <div className="spinner spinner-7">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                      </div>
                    </div>
                    <div
                      className="form-row"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        onClick={submitForm}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Userpasswordreset;
